// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"cd7d7d7f","937":"826a60e1"}[chunkId] + ".chunk.js";
};